// src/components/helpers/FormInput.js
import React, { memo } from "react";
import TextField from "@mui/material/TextField";

function FormInput({
  label,
  id,
  value,
  onChange,
  required,
  pattern,
  title,
  status,
  error,
  helperText,
  ...props
}) {
  const getBorderColor = () => {
    switch (status) {
      case "error":
        return "#f44336";
      case "warning":
        return "#ffd500";
      case "success":
        return "#4caf50";
      default:
        return "";
    }
  };

  return (
    <TextField
      label={label}
      id={id}
      variant="outlined"
      fullWidth
      required={required}
      value={value}
      onChange={onChange}
      pattern={pattern}
      title={title}
      error={error}
      helperText={helperText}
      {...props}
      className="form-control"
      InputProps={{
        ...props.InputProps,
        style: {
          borderColor: getBorderColor(),
        },
      }}
      InputLabelProps={{
        ...props.InputLabelProps,
        style: {
          color: getBorderColor(),
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: getBorderColor(),
          },
          "&:hover fieldset": {
            borderColor: getBorderColor(),
          },
          "&.Mui-focused fieldset": {
            borderColor: getBorderColor(),
          },
        },
      }}
    />
  );
}

export default memo(FormInput);
